/*
 * @Author: huangdingkun huangdingkun@redbirdedu.com
 * @Date: 2023-01-06 15:54:32
 * @LastEditors: huangdingkun huangdingkun@redbirdedu.com
 * @LastEditTime: 2023-02-20 11:04:34
 * @FilePath: \web\src\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import "core-js/es";
import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import React from "react";
import {createRoot} from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./services/serviceWorker";
import {BrowserRouter} from "react-router-dom";
// antD设置默认中文
import {ConfigProvider} from "antd";
import zhCN from "antd/lib/locale/zh_CN";
import enGB from "antd/lib/locale/en_GB";
import "./utils/network";
import moment from "moment";
import "moment/locale/zh-cn";
import {Inspector} from "react-dev-inspector";

const InspectorWrapper = process.env.NODE_ENV === "development"
  ? Inspector
  : React.Fragment;

moment.locale("zh-cn");

const localLang = window.localStorage.getItem("language") !== "en" ? zhCN : enGB;

const container = document.getElementById("root");

const app = createRoot(container);

app.render(
  <React.StrictMode>
    <InspectorWrapper
      keys={["shift", "alt", "c"]} // default keys
    >
      <ConfigProvider locale={localLang}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ConfigProvider>
    </InspectorWrapper>
  </React.StrictMode>

);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
